export const getTeamLogo = teamAbbr => {
  return `/team-logos/${teamAbbr}.png`;
};